import { useState } from "react";

const FAQS = [
  {
    q: "为什么“吃瓜官网”真假这么难分辨？",
    a: "因为仿冒站会完整复制官方页面外观，只改动域名或引导动作。多数人在手机端很少留意地址栏，加上页面高度相似，就容易被带偏。破解的办法不是看长相，而是比域名、查备案、核入口。",
  },
  {
    q: "域名只差一个字母，怎么避免点错？",
    a: "优先直接输入或收藏官方网址，尽量不从搜索结果、短信和弹窗进入。注意 0 与 O、1 与 l、连字符与下划线等易混字符，也可以把常用入口保存成书签，从书签里访问。",
  },
  {
    q: "如何快速核验网站是否正规、有没有备案？",
    a: "经营性正规网站一般会在页脚公示运营主体与备案编号。可把编号拿到工信部 ICP/IP 地址/域名信息备案管理系统查询，确认主体名称是否真实存在、是否与页面自称的运营方一致。查询不到的就要高度警惕。",
  },
  {
    q: "在可疑页面填了手机号或密码，该怎么办？",
    a: "立刻去真正官方渠道修改相关账号密码并开启两步验证，解绑可疑设备；若已泄露银行卡或验证码，第一时间联系银行冻结卡片并核对流水。必要时保留证据并向平台举报、向公安机关报案。",
  },
  {
    q: "被假冒网站骗了钱，还能追回来吗？",
    a: "能否追回取决于资金去向与取证时效。务必第一时间报警并提交转账记录、聊天截图、涉事网址等证据，同时联系支付机构申请止付。越早采取行动，追回的可能性越大。",
  },
  {
    q: "本指南和“吃瓜官网”官方是什么关系？",
    a: "本页是第三方安全科普内容，并非“吃瓜官网”的官方页面，也不代表任何特定平台背书。它只提供通用的真伪识别方法，帮你判断所访问的站点是否正规，具体请以各平台官方公布的渠道为准。",
  },
];

const LD = {
  "@context": "https://schema.org",
  "@type": "FAQPage",
  mainEntity: FAQS.map((f) => ({
    "@type": "Question",
    name: f.q,
    acceptedAnswer: { "@type": "Answer", text: f.a },
  })),
};

function FaqItem({
  item,
  open,
  onToggle,
}: {
  item: { q: string; a: string };
  open: boolean;
  onToggle: () => void;
}) {
  return (
    <div className="overflow-hidden rounded-lg border border-background-200 bg-background-50">
      <button
        type="button"
        onClick={onToggle}
        aria-expanded={open}
        className="flex w-full cursor-pointer items-center justify-between gap-4 p-4 text-left transition-colors hover:bg-background-100"
      >
        <h3 className="font-heading text-base leading-snug text-foreground-950">{item.q}</h3>
        <span className="flex h-8 w-8 shrink-0 items-center justify-center rounded-full border border-background-300 text-foreground-700">
          <i className={`ri-${open ? "subtract-line" : "add-line"}`}></i>
        </span>
      </button>
      <div
        className={`grid transition-all duration-300 ${
          open ? "grid-rows-[1fr] opacity-100" : "grid-rows-[0fr] opacity-0"
        }`}
      >
        <div className="overflow-hidden">
          <p className="px-4 pb-4 text-sm leading-7 text-foreground-700">{item.a}</p>
        </div>
      </div>
    </div>
  );
}

export default function Faq() {
  const [openIdx, setOpenIdx] = useState<number>(0);

  return (
    <section id="faq" className="scroll-mt-20">
      <div className="wrap py-10 md:py-14">
        <div className="grid gap-8 lg:grid-cols-[0.9fr_1.1fr]">
          <div>
            <p className="kicker mb-3">
              <i className="ri-chat-smile-3-line"></i>
              常见问题
            </p>
            <h2 className="font-heading text-2xl text-foreground-950 md:text-3xl">
              关于吃瓜官网真假的疑问，这里一一作答
            </h2>
            <p className="mt-3 text-[15px] leading-7 text-foreground-700">
              把大家问得最多的几个问题整理在此。如果你仍拿不准某个站点是否正规，最稳妥的做法永远是先不操作，再走官方渠道核实。
            </p>
            <div className="mt-6 flex items-start gap-3 rounded-lg border border-background-200 bg-background-100 p-4">
              <i className="ri-information-line mt-0.5 text-lg text-secondary-700"></i>
              <p className="text-sm leading-6 text-foreground-700">
                页面下方有免责说明与联系方式，内容仅供识别参考，不构成对任何平台的担保或背书。
              </p>
            </div>
          </div>

          <div className="space-y-3">
            {FAQS.map((f, i) => (
              <FaqItem
                key={f.q}
                item={f}
                open={openIdx === i}
                onToggle={() => setOpenIdx(openIdx === i ? -1 : i)}
              />
            ))}
          </div>
        </div>

        <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(LD) }} />
      </div>
    </section>
  );
}